export default __webpack_public_path__ + "static/media/bg-signup.bec2ba70.jpg";